<template>
  <DealSticker :icon @click="openModal(MODAL_NAMES.DEALS_MODAL)">
    <template #title>
      {{ i18n(translations.title) }}
    </template>
    <template #description>
      {{ i18n(translations.description) }}
      <IconChevronRight class="ml-4 shrink-0" size="small" />
    </template>
  </DealSticker>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

import DealSticker from '@backmarket/nuxt-layer-recommendation/DealSticker.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { openModal } from '@ds/components/ModalBase'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconPriceTagFilled } from '@ds/icons/IconPriceTagFilled'

import { MODAL_NAMES } from './DealSticker.constants'
import translations from './DealSticker.translations'

withDefaults(
  defineProps<{
    icon?: Component
  }>(),
  {
    icon: () => IconPriceTagFilled,
  },
)

const i18n = useI18n()
</script>
